module.exports = __webpack_public_path__ + "img/load-img.e2e6a125.gif";